import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as OrganizationKeyQL from "queries/organization-user";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { userParams } from "../params";

import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = ({ match: { params } }) => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({ history, match: { params: raw } }) => {
  const {
    parent: { base },
  } = useSectionContext();

  // Decoded for both readers below: the confirmation names the address, and the
  // mutation looks the user up by it.
  const params = userParams(raw);

  return (
    <CancellableContent>
      <Container className="mt-4">

        <Row>
          <Col>
            Removing the user <b>{params.email}</b>? This action will be
            permanent and can't be undone
          </Col>
        </Row>
        <Mutation
          mutation={OrganizationKeyQL.remove}
          update={OrganizationKeyQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: params,
            });
          }}
          onCompleted={() => {
            history.replace(base);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (

    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>

  );
};
